import { Place } from "@material-ui/icons";

const styles = (theme) => ({
    container: {
        flex: 1,
        margin: '0 auto',
        padding: 0,
        maxWidth: 600,
        overflow: 'hidden',
        '@media (max-width: 600px)': {
            margin: `0px ${theme.spacing(1)}px`,
        },
    },
    header: {
        backgroundColor: theme.custom.formBackground,
        padding: theme.spacing(2),
        display: 'flex',
        borderRadius: '10px 10px 0 0',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    headerTitle: {
        fontWeight: 700,
        fontSize: '1.25rem',
        display: 'flex',
        alignItems: 'center',
    },
    headerIcon: {
        marginRight: theme.spacing(1),
    },
    form: {
        padding: theme.spacing(2),
        width: '100%',
        backgroundColor: theme.custom.bgLightColor,
    },
    fieldTitle: {
        fontWeight: 700,
        marginBottom: theme.spacing(1),
    },
    twoColumnFieldTitle: {
        fontWeight: 700,
        marginBottom: theme.spacing(1),
    },
    formControl: {
        marginBottom: theme.spacing(4),
    },
    themeName: {
        marginTop: '0',
        marginBottom: theme.spacing(4),
        fontSize: '1rem',
    },
    inputField: {
        width: '100%',
        padding: '14px',
        marginBottom: theme.spacing(4),
        border: `1px solid ${theme.palette.primary.light}`,
        borderRadius: 10,
        backgroundColor: 'white',
        fontSize: '1rem',
        '&:focus': {
            outline: 'none',
            borderColor: theme.palette.primary.main,
        },
    },
    textareaField: {
        width: '100%',
        padding: '14px',
        border: `1px solid ${theme.palette.primary.light}`,
        borderRadius: '10px',
        fontSize: '1rem',
        resize: 'vertical',
        minHeight: '100px',
        '&:focus': {
            outline: 'none',
            borderColor: theme.palette.primary.main,
            backgroundColor: 'white',
        },
        '&::placeholder': {
            color: theme.palette.text.secondary,
        },
    },
    errorText: {
        color: theme.palette.error.main,
        fontSize: '0.75rem',
        marginTop: theme.spacing(0.5),
    },
    editingBannerContainer: {
        backgroundColor: theme.custom.bgLightColor,
        padding: theme.spacing(2),
    },
    editingBanner: {
        padding: '12px 12px 12px 0',
        border: `2px solid ${theme.palette.primary.main}`,  
        borderRadius: 10,
    },
    buttonContainer: {
        backgroundColor: theme.custom.formBackground,
        padding: theme.spacing(2),
        borderRadius: '0 0 10px 10px',
        display: 'flex',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
    },
    backButton: {
        flex: 1,
        backgroundColor: 'white',
        color: theme.palette.primary.main,
        borderRadius: 10,
        border: `2px solid ${theme.palette.primary.main}`,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            color: 'white',
            border: '0px',
        },
    },
    submitButton: {
        flex: 1,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        borderRadius: 10,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    twoColumnRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(4),
        '& > div': {
            flexBasis: 'calc(50% - 8px)',
            flexGrow: 1,
            [theme.breakpoints.down('xs')]: {
                flexBasis: '100%',
            },
        },
    },
    halfWidthField: {
        flex: 1,
        minWidth: 0, // Prevents flex items from overflowing
    },
    photoUpload: {
        width: '100%',
        padding: '14px',
        marginBottom: theme.spacing(4),
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 10,
        backgroundColor: 'white',
        fontSize: '1rem',
        '&:focus': {
            outline: 'none',
            borderColor: theme.palette.primary.dark,
        },
    },
    select: {
        width: '100%',
        padding: '14px',
        marginBottom: theme.spacing(4),
        border: `1px solid ${theme.palette.primary.light}`,
        borderRadius: 10,
        backgroundColor: 'white',
        color: theme.palette.text.primary,
        appearamce: 'none',
        fontSize: '1rem',
        '&:focus': {
            outline: 'none',
            borderColor: theme.palette.primary.main,
        },
    },
    placeholder: {
        color: theme.palette.text.secondary,
    },
    selectArrow: {
        position: 'absolute',
        right: '12px',
        top: '26.5px',
        transform: 'translateY(-50%)',
        pointerEvents: 'none',
        color: theme.palette.primary.main,
    },
    numberInputWrapper: {
        position: 'relative',
        width: '100%',  
        '& .MuiOutlinedInput-root': {
            paddingRight: '30px',
            width: '100%',
        },
    },
    numberArrows: {
        position: 'absolute',
        right: '5px',
        top: '-15px',
        bottom: '0',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    arrowButton: {
        padding: 0,
        minWidth: '20px',
        height: '20px',
        '& svg': {
            fontSize: '1rem',
        },
    },
    characterCount: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
    },
    selectItem: {
        display: 'flex',
        alignItems: 'center',
    },
    selectItemImage: {
        width: 24,
        height: 24,
        marginRight: theme.spacing(1),
    },
});

export default styles;